module.exports = __webpack_public_path__ + "static/img/logo.f8940d6c.png";